/* eslint-disable no-unused-expressions */
import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const ExpectationPage = () => {
  const { expectationApi } = apiPath;
  const [expectation, expectationLoading] = useFetch(expectationApi);
  if (expectationLoading) {
    return <Loading />;
  }
  const { qualityTitle, qualityPara, focusTitle, focusPara1, focusPara2 } =
    expectation;

  const data = [
    {
      elementType: "input",
      label: "Left Side's title",
      type: "Text",
      name: "qualityTitle",
      defaultValue: qualityTitle,
      required: true,
    },
    {
      elementType: "textField",
      label: "Left Side's Paragraph",
      type: "Text",
      name: "qualityPara",
      defaultValue: qualityPara,
      required: false,
    },
    {
      elementType: "input",
      label: "Right Side's title",
      type: "Text",
      name: "focusTitle",
      defaultValue: focusTitle,
      required: true,
    },
    {
      elementType: "textField",
      label: "Right Side's Paragraph 1",
      type: "Text",
      name: "focusPara1",
      defaultValue: focusPara1,
      required: false,
    },
    {
      elementType: "textField",
      label: "Right Side's Paragraph 2",
      type: "Text",
      name: "focusPara2",
      defaultValue: focusPara2,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(expectationApi, data);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ExpectationPage;
